var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('WyneLoverTopNav',{attrs:{"active-app":"atlas"}}),_c('MatchMedia',{attrs:{"query":"(max-width: 768px)"},scopedSlots:_vm._u([{key:"default",fn:function({ matches }){return [(matches)?_c('AtlasMobile'):_c('AtlasDesktop')]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }